<template>
    <div id="app">
        <el-container>
            <el-header style="background-color: #292c2d;color: white;line-height: 60px;">
                WuKong
            </el-header>
            <el-container>
                <el-aside width="120px" style="background-color: #f1f4f5;">
                    【敬告】仅供学习使用，请勿他用。
                </el-aside>
                <el-container>
                    <el-main>
                        <router-view/>
                    </el-main>
                </el-container>
            </el-container>
        </el-container>
    </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>

<style>
    html, body {
        margin: 0;
        padding: 0;
        height: 100%;
        font-family: Helvetica, Tahoma, Arial, "Hiragino Sans GB", "Hiragino Sans GB W3", "Microsoft YaHei", STXihei, STHeiti, Heiti, SimSun, sans-serif;
    }

    #app {
        height: 100%;
    }
    .el-container{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue